<kort id="gruppe-protokoll-oppsett">
  <kort-tittel>
    {{ 'Protokolloppsett' | translate }}
  </kort-tittel>

  @if (!erRedigeringsmodus()) {
    <p>{{ 'Angi ordlyden som skal brukes for beslutninger i protokolldokumentet'|translate }}</p>

    <tittel-verdi-samling stil="tabell">
      <tittel-verdi tittel="{{'Entall' | translate}}" [verdi]=" gruppe().oppsett.protokollValg.beslutningOrdlydEntall "/>
      <tittel-verdi tittel="{{'Flertall' | translate}}" [verdi]=" gruppe().oppsett.protokollValg.beslutningOrdlydFlertall "/>
    </tittel-verdi-samling>

    <kort-handlinger>
      <button mat-button (click)="rediger()" data-testid="rediger-knapp">
        <mat-icon>edit</mat-icon>
        {{ 'Rediger' | translate }}
      </button>
    </kort-handlinger>

  } @else {
    <form (ngSubmit)="lagre()" [formGroup]="skjema">
      <fieldset>
        <mat-form-field>
          <mat-label>{{ 'Entall (f.eks. Beslutning)' | translate }}</mat-label>
          <input matInput [formControl]="skjema.controls.beslutningOrdlydEntall" data-testid="beslutningOrdlyd-entall">
          @if (skjema.controls.beslutningOrdlydEntall.hasError('required')) {
            <mat-error>{{ 'Feltet er påkrevet' | translate }}</mat-error>
          }
          @if (skjema.controls.beslutningOrdlydEntall.hasError('maxlength')) {
            <mat-error>{{ skjema.controls.beslutningOrdlydEntall.errors | standardvalideringsfeil:'maxlength' }}</mat-error>
          }
        </mat-form-field>

        <mat-form-field>
          <mat-label>{{ 'Flertall (f.eks. Beslutninger)' | translate }}</mat-label>
          <input matInput [formControl]="skjema.controls.beslutningOrdlydFlertall" data-testid="beslutningOrdlyd-flertall">
          @if (skjema.controls.beslutningOrdlydFlertall.hasError('required')) {
            <mat-error>{{ 'Feltet er påkrevet' | translate }}</mat-error>
          }
          @if (skjema.controls.beslutningOrdlydFlertall.hasError('maxlength')) {
            <mat-error>{{ skjema.controls.beslutningOrdlydFlertall.errors | standardvalideringsfeil:'maxlength' }}</mat-error>
          }
        </mat-form-field>
      </fieldset>

      <kort-handlinger>
        <button mat-button type="button" (click)="avbrytRedigering()">{{ 'Avbryt' | translate }}</button>
        <button mat-flat-button color="primary" type="submit"
                [visSpinner]="lagrer()"
                [disabled]="lagrer() || skjema.invalid">
          {{ 'Lagre' | translate }}
        </button>
      </kort-handlinger>
    </form>
  }
</kort>
